import React from "react";
import { Box, Typography } from "@mui/material";
import { Check as CheckIcon, ChevronRight as ArrowIcon } from "@mui/icons-material";
import { HOL, holPulse } from "../../../UserSide/pages/holTheme";

export const HOL_SETUP_STEPS = ["Start", "How to Play", "Start Session"];

/** ● active · ✓ complete · ○ upcoming — the Play with Host setup progress. */
const HolHostStepper = ({ activeStep = 0 }) => (
  <Box
    component="ol"
    aria-label="Setup progress"
    sx={{
      listStyle: "none",
      m: 0,
      mb: { xs: 2.5, sm: 3.5 },
      p: 0,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      flexWrap: "wrap",
      gap: { xs: 0.5, sm: 1 },
    }}
  >
    {HOL_SETUP_STEPS.map((label, i) => {
      const done = i < activeStep;
      const active = i === activeStep;
      return (
        <React.Fragment key={label}>
          <Box
            component="li"
            aria-current={active ? "step" : undefined}
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1,
              px: { xs: 1.25, sm: 1.75 },
              py: 0.75,
              borderRadius: "999px",
              border: `1px solid ${
                active ? `${HOL.gold}88` : done ? `${HOL.higher}55` : "rgba(255,255,255,0.1)"
              }`,
              bgcolor: active
                ? "rgba(245,215,110,0.12)"
                : done
                  ? "rgba(168,224,99,0.08)"
                  : "rgba(255,255,255,0.02)",
              transition: "all 0.3s ease",
            }}
          >
            <Box
              sx={{
                width: 22,
                height: 22,
                borderRadius: "50%",
                display: "grid",
                placeItems: "center",
                flexShrink: 0,
                bgcolor: done ? HOL.higher : active ? HOL.gold : "transparent",
                border: done || active ? "none" : "2px solid rgba(255,255,255,0.28)",
                color: "#0a0a0a",
                animation: active ? `${holPulse} 2s ease-in-out infinite` : "none",
              }}
            >
              {done ? (
                <CheckIcon sx={{ fontSize: 15 }} />
              ) : active ? (
                <Box sx={{ width: 8, height: 8, borderRadius: "50%", bgcolor: "#0a0a0a" }} />
              ) : null}
            </Box>
            <Typography
              sx={{
                fontFamily: HOL.fontDisplay,
                fontWeight: active ? 800 : 700,
                fontSize: { xs: "0.78rem", sm: "0.88rem" },
                whiteSpace: "nowrap",
                color: active ? "#fff" : done ? HOL.higher : "rgba(255,255,255,0.45)",
              }}
            >
              {label}
            </Typography>
          </Box>
          {i < HOL_SETUP_STEPS.length - 1 ? (
            <Box component="li" aria-hidden sx={{ display: "flex" }}>
              <ArrowIcon
                sx={{ color: i < activeStep ? HOL.higher : "rgba(255,255,255,0.22)", fontSize: 20 }}
              />
            </Box>
          ) : null}
        </React.Fragment>
      );
    })}
  </Box>
);

export default HolHostStepper;
